import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BasicСhecksquare icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BasicСhecksquare } from '@sravni/design-system-icons'
 *
 * <BasicСhecksquare />
 * ```
 */
var BasicСhecksquare = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Basic\u0421hecksquare", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m8.021 9.715 2.143 2.143 7.143-7.143", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.593 10.429v5a1.428 1.428 0 0 1-1.428 1.428h-10a1.429 1.429 0 0 1-1.429-1.428v-10A1.429 1.429 0 0 1 5.165 4h7.857", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BasicСhecksquare };
//# sourceMappingURL=BasicСhecksquare.js.map
